import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hooks";

export const KeywordsHelmet = () => {
  const { t } = useTranslation();
  const REACT_APP_API_KEY = useAppSelector(
    (state) => state?.auth?.env?.REACT_APP_API_KEY
  );

  return (
    <Helmet>
      <meta charSet="UTF-8" />
      <title>{t("SEO.pageTitle")}</title>
      <meta name="google-signin-client_id" content={REACT_APP_API_KEY}></meta>
      <meta name="description" content={t("SEO.description")} />
      <meta name="keywords" content={t("SEO.keywords")} />
      <link
        rel="canonical"
        href={
          "https://" +
          window.location.hostname.replace("www.", "") +
          window.location.pathname
        }
      />
    </Helmet>
  );
};

export default KeywordsHelmet;
